/* Collection compare (sections/main-collection-product-grid.liquid; shells in snippets/collection-compare.liquid,
   ticks and "Viewed" tags on the compare: true cards of snippets/home-product-card.liquid, busy state on the expert
   band of snippets/collection-expert-band.liquid). Every word comes from the shells' data-* attributes and markup.
   - Selection: sessionStorage cfs_cmp = { c: collection handle, items: [handle…], dismissed, info }, reset on another
     collection. info keeps each picked card's model, brand, price, photo, ship line and URL, so the tray still shows
     a pick that a filter has hidden. A pick is the handle of the colour shown on its card; swatch clicks keep it
     current. Max 3; the other ticks are then disabled and say so.
   - Tray: 1 picked asks for one more, 2–3 open the panel. While it shows, --tidio-bottom lifts the chat bubble above
     it (the same one-time tidioChatApi.adjustStyles hookup as assets/product.js; snippets/chat-launcher.liquid's own
     launcher already follows --tidio-bottom).
   - Returning visitor: cfs_rv (snippets/recently-viewed-recorder.liquid) as it was at this visit's first collection
     page (sessionStorage cfs_cmp_rv), so this visit's views don't count as "last time". 2+ of them on this page and
     nothing picked or dismissed: the tray is pre-filled with the newest 2–3 as a suggestion (not stored until the
     visitor acts on it). Every card in the current cfs_rv gets the "Viewed" tag.
   - Busy state: clicks on compare cards' links are kept in sessionStorage cfs_cmp_views = { c, handles }, newest
     first. With 3+ for this collection and no add to cart this visit (sessionStorage cfs_atc, which nothing sets
     today, else /cart.js item_count > 0), the expert band names the newest 3 models and offers "Compare these", and
     the tray adds an "ask a specialist" link.
   - Panel: a dialog (focus trap, Esc / × / scrim close, focus back to the tray button, body scroll lock). Spec rows
     load from /products/<handle>?view=compare-data (templates/product.compare-data.liquid; no Accept header) only
     when it opens, cached per handle. Groups follow group_order, rows compare_order; a shipping row (each card's
     short ship line) ends the last group. Rows
     that differ are bold; "Only differences" hides the rest. Help block: Call, Chat (window.openTidio), "Online now"
     (updateOnline() in assets/collection-filters.js handles it as a [data-col-expert]). Email: the same Klaviyo
     client calls as the product page's document email (assets/product.js), subscription + "Requested Comparison".
   - Analytics: dataLayer events col_cmp_open / col_cmp_email / col_cmp_busy_click, pushed the way assets/product.js
     track() does.
   Re-applied after every grid change (cfs:grid-updated from assets/collection-filters.js) and on Back (pageshow). */
(() => {
  const tray = document.querySelector('[data-cmp-tray]');
  const panel = document.querySelector('[data-cmp-panel]');
  if (!tray || !panel) return;

  const T = tray.dataset;
  const P = panel.dataset;
  const collection = T.collection || '';
  const MAX = 3;
  const CHAT_MAX = 3; // names in a chat opener's {models}
  const KEY = 'cfs_cmp';
  const VIEWS = 'cfs_cmp_views';
  const RV_START = 'cfs_cmp_rv';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (tpl, map) => Object.keys(map).reduce((s, k) => s.split(k).join(map[k]), tpl || '');
  const text = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
  const track = (name) => { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: name }); };
  const store = {
    get(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage off */ } }
  };
  const X_ICON = ($('[data-cmp-dismiss]', tray) || {}).innerHTML || '';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // The dialog leaves the results column, so no ancestor's stacking context can put it under the header
  document.body.appendChild(panel);

  /* ---------- State ---------- */
  let state;
  function loadState() {
    const s = store.get(KEY);
    state = s && s.c === collection && Array.isArray(s.items)
      ? { c: collection, items: s.items.slice(0, MAX), dismissed: !!s.dismissed, info: s.info || {} }
      : { c: collection, items: [], dismissed: false, info: {} };
  }
  function save() {
    const info = {};
    state.items.forEach((h) => { if (state.info[h]) info[h] = state.info[h]; });
    state.info = info;
    store.set(KEY, state);
  }
  loadState();

  let sugg = null;            // returning-visitor suggestion: handles, not stored until acted on
  let suggestAllowed = true;  // once the visitor acts, no new suggestion on this page view
  let busy = false;
  const current = () => sugg || state.items;

  /* ---------- Cards ---------- */
  const grid = () => document.getElementById('product-grid');
  const cmpCards = () => { const g = grid(); return g ? $$(':scope > li[data-cmp]', g) : []; };
  const pathHandle = (url) => {
    const m = /\/products\/([^/?#]+)/.exec(url || '');
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  };
  // The card showing this handle, or the card that has it as a colour
  function cardFor(h) {
    if (!h) return null;
    const list = cmpCards();
    return list.find((li) => li.dataset.handle === h)
      || list.find((li) => $$('.hc-sw', li).some((b) => pathHandle(b.dataset.url) === h))
      || null;
  }
  // The ship line: with a ship day, the phone card's short line ("Ships today · Free"); otherwise as the card
  // shows it at this width (hidden spans left out)
  function shipText(li) {
    const el = $('.hc-ship', li);
    if (!el) return '';
    const day = text($('.hc-ship__day', el));
    const free = text($('.hc-ship__free.hc-ship__m', el));
    if (day && free) {
      const sep = $('.hc-ship__sep.hc-ship__m', el);
      return (day + (sep ? sep.textContent : ' ') + free).replace(/\s+/g, ' ').trim();
    }
    let out = '';
    el.childNodes.forEach((n) => {
      if (n.nodeType === 3) out += n.textContent;
      else if (n.nodeType === 1 && n.tagName.toLowerCase() !== 'svg' && n.getClientRects().length) out += n.textContent;
    });
    return out.replace(/\s+/g, ' ').trim();
  }
  function infoFrom(li) {
    const img = $('.hc-img img', li);
    const link = $('.hc-card__link', li);
    return {
      m: text($('.hc-model', li)), b: text($('.hc-brand', li)), p: text($('.hc-price', li)),
      i: img ? (img.currentSrc || img.src) : '', s: shipText(li), u: link ? link.href : ''
    };
  }
  function info(h) {
    const li = cardFor(h);
    if (li && li.dataset.handle === h) state.info[h] = infoFrom(li);
    return state.info[h] || (li ? infoFrom(li) : { m: h });
  }

  // Picks restored from storage show their own colour on the card (the swatch does the switching)
  function syncSwatches() {
    state.items.forEach((h) => {
      if (cmpCards().some((li) => li.dataset.handle === h)) return;
      const li = cardFor(h);
      const sw = li && $$('.hc-sw', li).find((b) => pathHandle(b.dataset.url) === h);
      if (sw) sw.click();
    });
  }

  function applyCards() {
    const picks = current();
    const full = picks.length >= MAX;
    cmpCards().forEach((li) => {
      const label = $('.hc-cmp', li);
      const box = label && $('[data-cmp-tick]', label);
      if (!box) return;
      const on = picks.indexOf(li.dataset.handle) !== -1;
      const off = !on && full;
      label.hidden = false;
      box.checked = on;
      box.disabled = off;
      li.classList.toggle('is-picked', on);
      const word = label.lastElementChild;
      if (off) { label.title = T.tplMax || ''; word.textContent = T.tplMax || ''; }
      else { label.removeAttribute('title'); word.textContent = T.tplTick || ''; }
    });
  }

  /* ---------- Recently viewed ---------- */
  function rvList() {
    try {
      const list = JSON.parse(localStorage.getItem('cfs_rv') || '[]');
      return Array.isArray(list) ? list.filter((x) => x && typeof x.h === 'string') : [];
    } catch (e) { return []; }
  }
  let rvStart = store.get(RV_START);
  if (!Array.isArray(rvStart)) { rvStart = rvList(); store.set(RV_START, rvStart); }

  // Cards on this page for these entries, newest first, one per card (by handle, colour, or family)
  function rvCards(list) {
    const out = [];
    const cardsNow = cmpCards();
    list.forEach((x) => {
      const li = cardFor(x.h) || cardsNow.find((c) => x.f != null && c.dataset.family === String(x.f));
      if (li && out.indexOf(li) === -1) out.push(li);
    });
    return out;
  }

  function applyViewed() {
    const seen = rvCards(rvList());
    cmpCards().forEach((li) => {
      const tag = $('.hc-seen', li);
      if (!tag) return;
      const on = seen.indexOf(li) !== -1;
      tag.textContent = on ? (T.tplViewed || '') : '';
      tag.hidden = !on || !T.tplViewed;
    });
  }

  function maybeSuggest() {
    if (!suggestAllowed || sugg || state.items.length || state.dismissed) return;
    const found = rvCards(rvStart).slice(0, MAX);
    if (found.length >= 2) sugg = found.map((li) => li.dataset.handle);
  }

  /* ---------- Tray ---------- */
  const trayTitle = $('[data-cmp-title]', tray);
  const traySub = $('[data-cmp-sub]', tray);
  const traySlots = $('[data-cmp-slots]', tray);
  const trayClear = $('[data-cmp-clear]', tray);
  const trayOpen = $('[data-cmp-open]', tray);
  const trayDismiss = $('[data-cmp-dismiss]', tray);

  function renderTray() {
    const picks = current();
    const n = picks.length;
    tray.hidden = n === 0;
    if (n === 0) { setTidio(); return; }

    if (sugg) {
      trayTitle.innerHTML = '<span class="t-full">' + esc(T.tplReturnTitle) + '</span><span class="t-short">' + esc(T.tplReturnTitleShort) + '</span>';
      traySub.textContent = fill(T.tplReturnSub, { __count__: n });
    } else {
      trayTitle.textContent = n < 2 ? T.tplAddMore : fill(P.tplTitle, { __count__: n });
      if (busy && T.tplAsk) traySub.innerHTML = esc(T.tplBusySub) + ' <button type="button" class="cmp-tray__ask" data-cmp-ask>' + esc(T.tplAsk) + '</button>';
      else traySub.textContent = T.tplSub || '';
    }

    let html = '';
    for (let k = 0; k < MAX; k += 1) {
      const h = picks[k];
      if (!h) { html += '<li class="cmp-slot cmp-slot--empty">' + esc(T.tplSlot) + '</li>'; continue; }
      const d = info(h);
      html += '<li class="cmp-slot"><span class="cmp-slot__img">'
        + (d.i ? '<img src="' + esc(d.i) + '" alt="" width="44" height="44" loading="lazy">' : '')
        + '</span><span class="cmp-slot__txt"><span class="cmp-slot__model">' + esc(d.m) + '</span><span class="cmp-slot__price">' + esc(d.p) + '</span></span>'
        + '<button type="button" class="cmp-slot__x" data-cmp-unpick="' + esc(h) + '" aria-label="' + esc(fill(T.tplRemove, { __model__: d.m })) + '">' + X_ICON + '</button></li>';
    }
    traySlots.innerHTML = html;

    trayClear.textContent = sugg ? T.tplDismiss : T.tplClear;
    trayOpen.disabled = n < 2;
    trayOpen.textContent = n < 2 ? T.tplTick : fill(T.tplButton, { __count__: n });
    trayDismiss.hidden = !sugg;
    setTidio();
  }

  /* ---------- Chat bubble above the tray ---------- */
  const TIDIO_DEFAULT_BOTTOM = 10;
  const TIDIO_GAP = 12;
  function setTidio() {
    const px = tray.hidden ? TIDIO_DEFAULT_BOTTOM : Math.ceil(tray.getBoundingClientRect().height) + TIDIO_GAP;
    document.documentElement.style.setProperty('--tidio-bottom', px + 'px');
  }
  let tidioHooked = false;
  function onTidioChatApiReady() {
    if (tidioHooked) return;
    tidioHooked = true;
    window.tidioChatApi.adjustStyles(`#tidio { bottom: var(--tidio-bottom, ${TIDIO_DEFAULT_BOTTOM}px) !important; transition: bottom .28s ease !important; }`);
    setTidio();
  }
  if (window.tidioChatApi) window.tidioChatApi.on('ready', onTidioChatApiReady);
  else document.addEventListener('tidioChat-ready', onTidioChatApiReady);
  if ('ResizeObserver' in window) new ResizeObserver(() => { if (!tray.hidden) setTidio(); }).observe(tray);

  /* Chat opens on the 'compare' question naming the models in the tray / panel (assets/footer.js openTidio),
     at most CHAT_MAX names (the first ones) */
  function openChat() {
    const panelOpen = !panel.hidden;
    const picks = (panelOpen ? state.items : current()).slice(0, MAX);
    const models = joinNames(picks.map((h) => info(h).m).filter(Boolean).slice(0, CHAT_MAX));
    closePanel(true);
    if (typeof window.openTidio === 'function') window.openTidio('compare', { models });
    else if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') window.tidioChatApi.open();
  }

  /* ---------- Busy state ---------- */
  function views() {
    const v = store.get(VIEWS);
    return v && v.c === collection && Array.isArray(v.handles) ? v.handles : [];
  }
  function recordView(h) {
    if (!h) return;
    const list = views().filter((x) => x !== h);
    list.unshift(h);
    store.set(VIEWS, { c: collection, handles: list.slice(0, 12) });
  }

  let cartCheck = null;
  function checkBusy() {
    if (views().length < 3) return Promise.resolve(false);
    let atc = null;
    try { atc = sessionStorage.getItem('cfs_atc'); } catch (e) { atc = null; }
    if (atc) return Promise.resolve(false);
    if (!cartCheck) {
      cartCheck = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((c) => !!(c && c.item_count > 0))
        .catch(() => true); // unknown cart: stay quiet
    }
    return cartCheck.then((hasItems) => !hasItems);
  }

  function busyCards() {
    const out = [];
    views().forEach((h) => {
      if (out.length >= MAX) return;
      const li = cardFor(h);
      if (li && out.indexOf(li) === -1) out.push(li);
    });
    return out;
  }
  function joinNames(names) {
    try {
      return new Intl.ListFormat(document.documentElement.lang || undefined, { style: 'long', type: 'conjunction' }).format(names);
    } catch (e) { return names.join(', '); }
  }

  function applyBusy() {
    const band = $('#product-grid li[data-col-expert]');
    if (!band || !band.dataset.busyTitle) return;
    const list = busy ? busyCards() : [];
    if (list.length < 2) { delete band.dataset.chatModels; return; }
    const title = $('.col-expert__title', band);
    const sub = $('.col-expert__sub', band);
    const btn = $('[data-cmp-busy]', band);
    const names = joinNames(list.map((li) => text($('.hc-model', li))));
    // the band's chat button asks about these, first CHAT_MAX only (assets/collection-filters.js)
    band.dataset.chatModels = joinNames(list.slice(0, CHAT_MAX).map((li) => text($('.hc-model', li))));
    if (title) title.textContent = fill(band.dataset.busyTitle, { __models__: names });
    if (sub) {
      Array.from(sub.childNodes).forEach((n) => { if (n.nodeType === 3) n.remove(); });
      sub.insertBefore(document.createTextNode(band.dataset.busyText || ''), sub.firstChild);
    }
    if (btn) {
      btn.textContent = fill(band.dataset.busyButton, { __count__: list.length });
      btn.hidden = false;
    }
    band.classList.add('is-personal');
  }

  /* ---------- Panel ---------- */
  const dialog = $('.cmp__panel', panel);
  const heading = $('[data-cmp-heading]', panel);
  const table = $('[data-cmp-table]', panel);
  const body = $('[data-cmp-body]', panel);
  const diff = $('[data-cmp-diff]', panel);
  const mailbox = $('[data-cmp-mailbox]', panel);
  const mailText = $('[data-cmp-mail-text]', panel);
  const form = $('[data-cmp-mail]', panel);
  const mailErr = $('[data-cmp-mail-err]', panel);
  const mailFine = $('[data-cmp-mail-fine]', panel);
  const mailOk = $('[data-cmp-mail-ok]', panel);
  let groupOrder = [];
  try { groupOrder = JSON.parse(P.groups || '[]') || []; } catch (e) { groupOrder = []; }
  if (!Array.isArray(groupOrder)) groupOrder = [];

  // No custom headers: with Accept: application/json Shopify ignores ?view= and sends its own product JSON.
  // A response without a rows array is a failure (null, not cached).
  const cache = {};
  function getData(h) {
    if (!cache[h]) {
      cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '?view=compare-data')
        .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then((t) => {
          const j = JSON.parse(t);
          if (!j || !Array.isArray(j.rows)) throw new Error('No rows');
          return j;
        })
        .catch(() => { delete cache[h]; return null; });
    }
    return cache[h];
  }

  // Groups in group_order (others after), matched by group + label; within a group rows follow compare_order
  // ("o", ascending), then unnumbered rows in first-seen layout order (stable sort);
  // rows with no value at all are left out; the shipping row ends the last group_order group
  const order = (o) => (o == null || o === '' || !isFinite(Number(o)) ? null : Number(o));
  function byOrder(a, b) {
    if (a.o == null) return b.o == null ? 0 : 1;
    if (b.o == null) return -1;
    return a.o - b.o;
  }
  function buildRows(picks, data) {
    const groups = new Map();
    data.forEach((d, i) => {
      ((d && Array.isArray(d.rows)) ? d.rows : []).forEach((r) => {
        if (!r || !r.g || !r.l) return;
        if (!groups.has(r.g)) groups.set(r.g, new Map());
        const rows = groups.get(r.g);
        if (!rows.has(r.l)) rows.set(r.l, { l: r.l, o: null, v: picks.map(() => null) });
        const row = rows.get(r.l);
        if (row.o == null) row.o = order(r.o);
        if (row.v[i] == null && r.v != null && String(r.v).trim() !== '') row.v[i] = String(r.v);
      });
    });
    const names = groupOrder.filter((g) => groups.has(g))
      .concat(Array.from(groups.keys()).filter((g) => groupOrder.indexOf(g) === -1));
    const out = names
      .map((g) => ({ g, rows: Array.from(groups.get(g).values()).filter((r) => r.v.some((v) => v != null)).sort(byOrder) }))
      .filter((grp) => grp.rows.length);
    const ship = picks.map((h) => info(h).s || null);
    if (P.tplShip && ship.some((v) => v)) {
      const last = groupOrder[groupOrder.length - 1];
      let grp = last ? out.find((x) => x.g === last) : out[out.length - 1];
      if (!grp && last) { grp = { g: last, rows: [] }; out.push(grp); }
      if (grp) grp.rows.push({ l: P.tplShip, v: ship });
    }
    return out;
  }

  const norm = (v) => (v == null ? '' : String(v).replace(/\s+/g, ' ').trim().toLowerCase());

  let panelGen = 0;
  let lastRows = [];
  function renderPanel(data) {
    const picks = state.items.slice(0, MAX);
    const n = picks.length;
    const cols = n < MAX ? n + 1 : MAX;
    heading.textContent = fill(P.tplTitle, { __count__: n });
    if (mailText) mailText.textContent = fill(P.tplEmailText, { __count__: n });
    table.style.setProperty('--cols', cols);

    const fillCell = (cls) => (n < MAX ? '<div class="cmp__val cmp__val--fill ' + cls + '" aria-hidden="true"></div>' : '');
    let html = '<div class="cmp__row" role="row"><div class="cmp__corner" aria-hidden="true"></div>';
    picks.forEach((h, i) => {
      const d = info(h);
      const j = data && data[i];
      const url = (j && j.url) || d.u || (root + 'products/' + encodeURIComponent(h));
      const img = d.i || (j && j.image) || '';
      const model = d.m || (j && j.model) || '';
      html += '<div class="cmp__prod" role="columnheader">'
        + '<div class="cmp__pimg">' + (img ? '<img src="' + esc(img) + '" alt="" width="240" height="240" loading="lazy">' : '')
        + '<button type="button" class="cmp__rm" data-cmp-unpick="' + esc(h) + '" aria-label="' + esc(fill(T.tplRemove, { __model__: model })) + '">' + X_ICON + '</button></div>'
        + (d.b ? '<span class="cmp__brand">' + esc(d.b) + '</span>' : '')
        + '<span class="cmp__model">' + esc(model) + '</span>'
        + '<span class="cmp__price">' + esc(d.p || (j && j.price) || '') + '</span>'
        + '<span class="cmp__ship">' + esc(d.s) + '</span>'
        + '<a class="col-btn col-btn--dark cmp__view" href="' + esc(url) + '">' + esc(table.dataset.view) + '</a></div>';
    });
    if (n < MAX) html += '<div class="cmp__prod"><button type="button" class="cmp__add" data-cmp-close>' + esc(table.dataset.add) + '</button></div>';
    html += '</div>';

    if (!data) {
      for (let r = 0; r < 4; r += 1) {
        html += '<div class="cmp__row" role="row"><div class="cmp__lab is-loading" role="rowheader"></div>'
          + picks.map(() => '<div class="cmp__val is-loading" role="cell"></div>').join('') + fillCell('') + '</div>';
      }
      table.setAttribute('aria-busy', 'true');
      lastRows = [];
    } else {
      lastRows = buildRows(picks, data);
      lastRows.forEach((grp) => {
        let rowsHtml = '';
        let allSame = true;
        grp.rows.forEach((r) => {
          const same = r.v.every((v) => norm(v) === norm(r.v[0]));
          if (!same) allSame = false;
          const cls = same ? 'is-same' : 'is-diff';
          rowsHtml += '<div class="cmp__row" role="row"><div class="cmp__lab ' + cls + '" role="rowheader">' + esc(r.l) + '</div>'
            + r.v.map((v) => '<div class="cmp__val ' + cls + (v == null ? ' cmp__val--none' : '') + '" role="cell">' + (v == null ? '—' : esc(v)) + '</div>').join('')
            + fillCell(cls) + '</div>';
        });
        html += '<div class="cmp__row' + (allSame ? ' is-same' : '') + '" role="row"><p class="cmp__group" role="rowheader">' + esc(grp.g) + '</p></div>' + rowsHtml;
      });
      table.removeAttribute('aria-busy');
    }
    table.innerHTML = html;
  }

  function loadPanel() {
    const gen = ++panelGen;
    const picks = state.items.slice(0, MAX);
    renderPanel(null);
    Promise.all(picks.map(getData)).then((data) => {
      if (gen !== panelGen || panel.hidden) return;
      renderPanel(data);
    });
  }

  let opener = null;
  function openPanel(from) {
    if (sugg) { state.items = sugg.slice(); sugg = null; suggestAllowed = false; save(); applyCards(); renderTray(); }
    if (state.items.length < 2) return;
    opener = from || null;
    resetMail();
    panel.hidden = false;
    document.documentElement.classList.add('cmp-lock');
    body.scrollTop = 0;
    loadPanel();
    const close = $('.cmp__close', panel);
    if (close) close.focus();
    track('col_cmp_open');
  }

  function closePanel(silent) {
    if (panel.hidden) return;
    panelGen += 1;
    panel.hidden = true;
    document.documentElement.classList.remove('cmp-lock');
    if (silent) return;
    let target = null;
    if (!tray.hidden && !trayOpen.disabled) target = trayOpen;
    else if (opener && !opener.disabled && document.contains(opener) && opener.getClientRects().length) target = opener;
    else {
      const li = cardFor(state.items[0]);
      target = li && $('[data-cmp-tick]', li);
    }
    if (target) target.focus();
  }

  function trapFocus(e) {
    const items = $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', dialog)
      .filter((el) => el.getClientRects().length > 0);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Email this comparison (Klaviyo client API, as assets/product.js) ---------- */
  function resetMail() {
    if (!form) return;
    form.hidden = false;
    if (mailFine) mailFine.hidden = false;
    mailOk.hidden = true;
    mailOk.textContent = '';
    mailErr.hidden = true;
    mailErr.textContent = '';
    const btn = $('button[type="submit"]', form);
    if (btn) btn.disabled = false;
  }
  function post(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(P.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    }).then((r) => { if (!r.ok) throw new Error(r.status); });
  }
  const abs = (u) => { try { return u ? new URL(u, window.location.origin).href : ''; } catch (e) { return u || ''; } };

  if (form && P.key && P.list) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = $('input[type="email"]', form);
      const btn = $('button[type="submit"]', form);
      const email = input.value.trim();
      mailErr.hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        mailErr.textContent = P.tplError || '';
        mailErr.hidden = !P.tplError;
        input.focus();
        return;
      }
      btn.disabled = true;
      const picks = state.items.slice(0, MAX);
      Promise.all(picks.map(getData)).then((data) => {
        const rows = [];
        buildRows(picks, data).forEach((grp) => grp.rows.forEach((r) => rows.push({ group: grp.g, label: r.l, values: r.v })));
        const products = picks.map((h, i) => {
          const d = info(h);
          const j = data[i] || {};
          return { title: j.title || d.m || '', model: d.m || j.model || '', url: abs(j.url || d.u), image: abs(d.i || j.image), price: d.p || j.price || '' };
        });
        const profile = { data: { type: 'profile', attributes: { email } } };
        return Promise.all([
          post('subscriptions', { data: { type: 'subscription',
            attributes: { profile, custom_source: 'Collection compare' },
            relationships: { list: { data: { type: 'list', id: P.list } } } } }),
          post('events', { data: { type: 'event', attributes: {
            properties: { collection: collection, collection_title: P.collectionTitle || '', products, rows },
            metric: { data: { type: 'metric', attributes: { name: P.metric } } },
            profile } } })
        ]);
      }).then(() => {
        form.hidden = true;
        if (mailFine) mailFine.hidden = true;
        mailOk.hidden = false;
        mailOk.textContent = fill(P.tplSuccess, { __email__: email });
        mailOk.focus();
        track('col_cmp_email');
      }).catch(() => {
        mailErr.textContent = P.tplError || '';
        mailErr.hidden = !P.tplError;
        btn.disabled = false;
      });
    });
  }

  /* ---------- Selection changes ---------- */
  function setItems(items) {
    sugg = null;
    suggestAllowed = false;
    state.items = items.slice(0, MAX);
    save();
    applyCards();
    renderTray();
  }

  function unpick(h) {
    const list = sugg || state.items;
    const next = list.filter((x) => x !== h);
    if (sugg && !next.length) state.dismissed = true;
    setItems(next);
    if (!panel.hidden) {
      if (state.items.length < 2) closePanel();
      else { loadPanel(); const close = $('.cmp__close', panel); if (close) close.focus(); }
    }
  }

  document.addEventListener('change', (e) => {
    const box = e.target;
    if (!(box instanceof HTMLInputElement)) return;
    if (box.matches('[data-cmp-diff]')) { panel.classList.toggle('is-diffonly', box.checked); return; }
    if (!box.matches('[data-cmp-tick]')) return;
    const li = box.closest('li[data-cmp]');
    const h = li && li.dataset.handle;
    if (!h) return;
    const items = current().filter((x) => x !== h);
    if (box.checked) {
      if (items.length >= MAX) { box.checked = false; return; }
      items.push(h);
      state.info[h] = infoFrom(li);
    }
    setItems(items);
  });

  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;

    // Swatch: the card's handle follows the colour shown (assets/product-card.js switches link, photo and price)
    const sw = t.closest('.hc-sw');
    if (sw) {
      const li = sw.closest('li[data-cmp]');
      const nh = li && pathHandle(sw.dataset.url);
      const oh = li && li.dataset.handle;
      if (nh && nh !== oh) {
        li.dataset.handle = nh;
        [state.items, sugg].forEach((list) => {
          if (!list) return;
          const i = list.indexOf(oh);
          if (i !== -1) list[i] = nh;
        });
        if (state.items.indexOf(nh) !== -1) save();
        setTimeout(() => { if (state.items.indexOf(nh) !== -1) state.info[nh] = infoFrom(li); save(); applyCards(); renderTray(); }, 0);
      }
      return;
    }

    // Product opened from the grid: counts towards the busy state
    const link = t.closest('#product-grid li[data-cmp] .hc-card__link');
    if (link) { recordView(link.closest('li[data-cmp]').dataset.handle || pathHandle(link.href)); return; }

    const x = t.closest('[data-cmp-unpick]');
    if (x) { unpick(x.getAttribute('data-cmp-unpick')); return; }

    if (t.closest('[data-cmp-open]')) { openPanel(trayOpen); return; }
    if (t.closest('[data-cmp-clear]') || t.closest('[data-cmp-dismiss]')) {
      if (sugg || t.closest('[data-cmp-dismiss]')) state.dismissed = true;
      setItems([]);
      const first = cmpCards()[0];
      const tick = first && $('[data-cmp-tick]', first);
      if (tick) tick.focus();
      return;
    }
    if (t.closest('[data-cmp-close]')) { closePanel(); return; }
    if (t.closest('[data-cmp-chat]') || t.closest('[data-cmp-ask]')) { openChat(); return; }

    const these = t.closest('[data-cmp-busy]');
    if (these) {
      const handles = busyCards().map((li) => li.dataset.handle);
      if (handles.length < 2) return;
      busyCards().forEach((li) => { state.info[li.dataset.handle] = infoFrom(li); });
      setItems(handles);
      track('col_cmp_busy_click');
      openPanel(these);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (panel.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); closePanel(); }
    else if (e.key === 'Tab') trapFocus(e);
  });

  /* ---------- Grid changes, Back, start ---------- */
  function refresh() {
    syncSwatches();
    maybeSuggest();
    applyCards();
    applyViewed();
    renderTray();
    applyBusy();
  }
  function start() {
    refresh();
    checkBusy().then((b) => {
      busy = b;
      renderTray();
      applyBusy();
    });
  }
  document.addEventListener('cfs:grid-updated', refresh);
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    loadState();
    cartCheck = null;
    closePanel(true);
    start();
  });
  start();
})();
